<template>
    <div>
        <vx-card titleIcon="FilterIcon" title="Advanced Filters">
            <div class="vx-row mt-2">
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">General</label>
                    <vs-input class="w-full" v-model="filters['search']"></vs-input>
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">View By FG Stock Status</label>
                    <v-select :clearable="true" placeholder="" label="key" v-model="filters['status']" multiple
                        :options="fg_stock_status_options" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :reduce="option => option.value"></v-select>
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full mb-5">
                    <label class="text-sm opacity-100 text-bold">Shelf Life</label>
                    <v-select :clearable="true" placeholder="" @input="onSelectCustomFilter" label="key"
                        :options="custom_filter_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value"></v-select>
                </div>
            </div>
            <div class="vx-row mb-4 hidden">
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Manufacturing Date From</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['manufacture-from']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['manufacture-from']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Manufacturing Date To</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['manufacture-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['manufacture-to']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expiry Date From</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['expiry-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['expiry-to']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expiry Date To</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['expiry-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['expiry-to']"
                        placeholder="Choose Date" />
                </div>
            </div>
            <!-- <div class="vx-row mt-5">
                <div class="vx-col w-full ml-auto">
                    <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                        v-on:click="filters = {}">CLEAR</vs-button>
                </div>
            </div> -->
        </vx-card>
        <vx-card class="mt-4">
            <div class="vx-row">
                <div class="vx-col w-full">

                    <div slot="no-body" class="mt-4">
                        <vs-table id="sundry-item-list-table" :max-items="(meta.per_page) ? meta.per_page : 10"
                            :data="items" sort :sst="true" stripe
                            class="table-dark-inverted table-auto vs-con-loading__container">

                            <template slot="thead">
                                <vs-th width="10%" class="text-xs">ITS CODE</vs-th>
                                <vs-th width="10%" class="text-xs" >BATCH CODE</vs-th>
                                <vs-th width="10%" class="text-xs">MANUFACTURE DATE</vs-th>
                                <vs-th width="10%" class="text-xs">EXP DATE</vs-th>
                                <vs-th width="5%" class="text-xs">MLOR %</vs-th>
                                <vs-th width="10%" class="text-xs">BATCH QTY (KG)</vs-th>
                                <vs-th width="10%" class="text-xs">COMPLETED/AVAILABLE QTY (KG)</vs-th>
                                <vs-th width="10%" class="text-xs">PRODUCT ORDER CODE</vs-th>
                                <vs-th width="15%" class="text-xs">STATUS</vs-th>
                                <vs-th width="10%" class="text-xs">ACTION</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr
                                    @click.native="onClickAssignFormulation(data[indextr].formulation_id, data[indextr].id, data[indextr].status)"
                                    class="text-sm" style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].formulation_code">
                                       <HyperLink :id="data[indextr].formulation_id" type="formulation"> {{ data[indextr].formulation_code }}</HyperLink>
                                    </vs-td>

                                    <vs-td class="text-primary font-semibold" :data="data[indextr].work_order">
                                        <HyperLink :id="data[indextr].work_order_id" type="work-order"> {{ data[indextr].work_order }}</HyperLink>
                                    </vs-td>

                                    <vs-td :data="data[indextr].manufacture_date">
                                        {{ data[indextr].manufacture_date }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].expiration_date">
                                        {{ data[indextr].expiration_date }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].mlor">
                                        {{ data[indextr].mlor }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].total_quantity">
                                        {{ toFixed(data[indextr].total_quantity) }}
                                    </vs-td>


                                    <vs-td :data="data[indextr].completed_quantity">
                                        {{ toFixed(data[indextr].completed_quantity) }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].product_order_code">
                                        {{ data[indextr].product_order_code }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].status">
                                        <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                                            {{ data[indextr].status | stock_status_format }}
                                        </vs-chip>
                                    </vs-td>


                                    <vs-td>
                                        <div class="vx-row">
                                            <vx-tooltip style="z-index: 9999" text="Assign formulation stock" position="top"
                                                v-if="data[indextr].status === 'In_Stock'">
                                                <vs-button class="ml-3"
                                                    @click.stop="onClickAssignFormulation(data[indextr].formulation_id, data[indextr].id, data[indextr].status, data[indextr].completed_quantity)"
                                                    size="small" color="primary" type="border" icon-pack="feather"
                                                    icon="icon-share"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip style="z-index: 9999" text="Adjust formulation stock" position="top"
                                                v-if="['In_Stock', 'Expired', 'In-Dispatch'].includes(data[indextr].status)">
                                                <vs-button class="ml-3" @click.stop="onClickStockAdjust(data[indextr])"
                                                    size="small" color="primary" type="border" icon-pack="feather"
                                                    icon="icon-trending-up"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip style="z-index: 9999" text="FG Stock Activity Logs" position="top">
                                                <vs-button class="ml-3" @click.stop="onClickStockLog(data[indextr].log)"
                                                    size="small" color="warning" type="border" icon-pack="feather"
                                                    icon="icon-activity"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>


                        </vs-table>

                        <vs-pagination v-if="items.length > 0" v-on:changeMaxItems="changePage"
                            :size-array="meta.total ? meta.total : 20" :max-items="perPage" description-body="Rows per page"
                            description-connector="of" description-title="Records" description
                            :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
                            v-model="page" class="p-5">
                        </vs-pagination>


                    </div>
                </div>
            </div>
        </vx-card>

        <assign-formulation-stock-pop-up v-on:refreshData="refreshData" ref="assignFormulationStockPopUp" />
        <adjust-product-stock-pop-up ref="adjustProductStockPopUp" />
        <formulation-stock-log-pop-up ref="formulationStockLogPopUp"/>
    </div>
</template>
  
<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const ManufacturingRepository = RepositoryFactory.get('manufacturing')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList } from "@/constants/config";
import AssignFormulationStockPopUp from "@/components/popups/manufacturing/formulation-stock/AssignFormulationStockPopUp";
import AdjustProductStockPopUp
    from "@/components/popups/manufacturing/formulation-stock/AdjustProductStockPopUp";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import moment from "moment";
import FormulationStockLogPopUp from '@/components/popups/activity-logs/inventory/FormulationStockLogPopUp.vue';

export default {
    name: 'FormulationStockReport',
    props: {
        formulation_code: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            items: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
            activePrompt: false,
            current_stock_level: '',
            selected_product_id: '',
            fg_stock_status_options: [
                { key: 'In Stock', value: 'In_Stock' },
                { key: 'Out of Stock', value: 'Out_of_Stock' },
                { key: 'In Dispatch', value: 'In_Dispatch' },
                // { key: 'In Progress', value: 'In_Progress' },
                { key: 'Pending Dispatch', value: 'Pending Dispatch' },
                { key: 'Dispatched', value: 'Dispatched' },
                { key: 'Part Returned', value: 'Part_Returned' },
                { key: 'Returned', value: 'Returned' },
                { key: 'Customer Received', value: 'Customer_Received' },
            ],
            custom_filter_options: [
                { key: '30-90 days short shelf life', value: 1 },
                { key: 'Less than 30 days to expiry', value: 2 },
                { key: 'Expired', value: 3 },
            ],
        }
    },
    components: {
        'v-select': vSelect,
        flatPickr,
        AssignFormulationStockPopUp,
        AdjustProductStockPopUp,
        FormulationStockLogPopUp
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
    async mounted() {
        if (this.$route.query.code) {
            this.formulation_code = this.$route.query.code
        }
    },
    methods: {
        async refreshData() {
            this.fetchFormulationStockInventory()
        },
        async fetchFormulationStockInventory() {
            await this.$vs.loading({
                container: '#sundry-item-list-table',
                scale: 0.45
            })
            try {
                const { data } = await ManufacturingRepository.getFormulationStock(this.page, this.filterQuery, this.perPage)
                this.items = data.data
                // .filter((m) => m.status === 'In_Stock')
                this.meta = data.meta
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
        },

        filterQueryUpdate() {
            this.fetchFormulationStockInventory()
        },

        handleChangePage(page) {
            this.page = page;
            this.fetchFormulationStockInventory()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchFormulationStockInventory()
            }

        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        close() {
            this.activePrompt = false
        },
        onClickAssignFormulation(formulation_id, inventory_id, status, completed_quantity) {
            if (status === 'In_Stock') {
                this.$refs.assignFormulationStockPopUp.openPopup(formulation_id, inventory_id, completed_quantity)
            }
        },
        onClickStockAdjust(data) {
            if (['In_Stock', 'Expired', 'In-Dispatch'].includes(data.status)) {
                this.$refs.adjustProductStockPopUp.openPopup(data)
            }
        },
        onClickStockLog(logs) {
            this.$refs.formulationStockLogPopUp.openPopup(logs)
        },
        toFixed(number) {
            return Number(number).toFixed(2)
        },
        onSelectCustomFilter(value) {
            const today = moment().format('DD/MM/YYYY');
            let expiryFrom = '';
            let expiryTo = '';

            if (value === 1) {
                expiryFrom = moment(today, 'DD/MM/YYYY').add(30, 'days').format('DD/MM/YYYY');
                expiryTo = moment(today, 'DD/MM/YYYY').add(90, 'days').format('DD/MM/YYYY');
            } else if (value === 2) {
                expiryFrom = today;
                expiryTo = moment(today, 'DD/MM/YYYY').add(30, 'days').format('DD/MM/YYYY');
            } else if (value === 3) {
                expiryTo = today;
            }
            this.filterQuery = ''
            this.filterQuery += `&filter[expiry-from]=${expiryFrom}&filter[expiry-to]=${expiryTo}`;
            this.page = 1
            this.fetchFormulationStockInventory();
        }
    },
    watch: {
        page() {
            this.fetchFormulationStockInventory()
        },
        perPage() {
            this.fetchFormulationStockInventory()
        },
        formulation_code() {
            this.fetchFormulationStockInventory()
        }
    }
}
</script>
  
  
<style scoped>
.user-edit-popup>>>.vs-popup {
    min-height: 50% !important;
    min-width: 50% !important;
}

@media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup>>>.vs-popup {
        min-height: 50% !important;
        min-width: 65% !important;
    }
}
</style>
  